import { androidSpecialDownloadUrl, harmonyAppDownloadUrl, iosDownloadUrl } from '@/constant';
import platform from '@/shared/utils/platform';
import { getWisdomConfig } from '@/shared/wisdom';

const DOWNLOAD_PREFIX = 'https://cdn.51downapp.cn/hellobike/android/channel';


/**
 * 判断是否为支付宝环境
 */
function isAlipayEnv(): boolean {
  return platform.isAlipayMini || platform.isAlipayBrowser;
}

/**
 * APP跳转下载通用方法
 * - IOS跳转应用市场下载
 * - 安卓下载渠道包
 * - 鸿蒙跳华为鸿蒙应用市场下载哈啰app
 */
// 新项目授信成功支付宝引导页（/alipay-credit-guide），与老项目guide-download处理逻辑保持一致。需同步进行逻辑修改
export function redirectToAppDownload(): void {
  if (platform.isIOS) {
    window.location.href = iosDownloadUrl;
  } else if (platform.isAndroid) {
    let url = '';
    if (platform.isDingTalk) {
      url = `${DOWNLOAD_PREFIX}/finance003.apk`;
    } else {
      url = isAlipayEnv()
        ? `${DOWNLOAD_PREFIX}/finance004.apk`
        : androidSpecialDownloadUrl;
    }
    window.location.href = url;
  } else if (platform.isHarmony) {
    window.location.href = harmonyAppDownloadUrl;
  }
}

/**
 * 使用平台唤端能力唤起app（针对IOS、Android支付宝小程序授信失败场景下使用）
 * 用户下载app的情况下，会跳转到臻有钱首页
 * 用户未下载app的情况下，会跳转到应用市场下载app
 */
export async function redirectWithWisdom(): Promise<void> {
  //  wisdom配置链接 https://config.hellobike.cn/#/project/detail?projectName=AppFinanceH5Web&projectGuid=8fa0876b0e60472b9cbf257a9bc63ad4
  const urlConfig = await getWisdomConfig<{url: string}>('financeAppCallUrl');

  if (platform.isIOS) {
    window.location.href = urlConfig.url;
  } else if (platform.isAndroid) {
    let url = '';
    if (platform.isDingTalk) {
      url = `${DOWNLOAD_PREFIX}/finance003.apk`;
    } else {
      url = isAlipayEnv()
        ? urlConfig.url
        : androidSpecialDownloadUrl;
    }
    window.location.href = url;
  } else if (platform.isHarmony) {
    window.location.href = harmonyAppDownloadUrl;
  }
}

/**
 * 通过开关控制是否使用平台唤端能力唤起app
 */
export async function redirect(): Promise<void> {
  // Debug 模式检查
  const isDebug = localStorage.getItem('financeDebugMode') === 'true';
  // 正常模式：根据开关决定
  const platformCallConfig = await getWisdomConfig<{isUsePlatformCall: boolean}>('platformCallConfig');
  if (platformCallConfig.isUsePlatformCall || isDebug) {
    if (isDebug) {
      localStorage.removeItem('financeDebugMode');
    }
    await redirectWithWisdom();
  } else {
    redirectToAppDownload();
  }
}
